import { useState as classicUseState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { ClickAwayListener } from '@material-ui/core';
import { useNavigationState } from '@store/hookstate';
import { Icon as BlueIcon } from '@blueprintjs/core';

import { MenuContent } from './components';

import {
  Container,
  Block,
  RoleButton,
  RoleInput,
  IconWrapper,
} from './Menu.styles';

interface IRoleOptionsMenu {
  value: string;
  onChange: (...event: any[]) => void;
}

const RoleOptionsMenu = ({ value, onChange }: IRoleOptionsMenu) => {
  const [open, setOpen] = classicUseState(false);

  const navigationState = useNavigationState();
  const handleClickAway = () => {
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Container>
        <RoleButton
          onClick={() => {
            setOpen(!open);
          }}
          type="button"
        >
          <RoleInput placeholder="Select Role" value={value} />
          <IconWrapper>
            <BlueIcon
              icon={open ? 'chevron-up' : 'chevron-down'}
              color="#8F95B2"
            />
          </IconWrapper>
        </RoleButton>

        <CSSTransition
          in={open}
          timeout={300}
          classNames="my-node"
          unmountOnExit
          onEnter={() => setOpen(true)}
          onExited={() => setOpen(false)}
        >
          <Block
            width={
              navigationState.sidebarOpen.get()
                ? navigationState.maxLeft.get()
                : navigationState.minLeft.get()
            }
          >
            <MenuContent setOpenMenu={setOpen} onChange={onChange} />
          </Block>
        </CSSTransition>
      </Container>
    </ClickAwayListener>
  );
};

export { RoleOptionsMenu };
